<div class="info-block background-{{ background }}">
  <i class="fa {{ iconClass }} icon icon--{{ mode }}"></i>
  @if (infoText) {
    <div class="info-text" [innerHTML]="infoText" [ngStyle]="customStyles" [style.font-size]="fontSize | tiPxToRem"></div>
  } @else {
    <div>
      <div class="info-title">{{ title }}</div>
      <div class="info-text"><ng-content></ng-content></div>
    </div>
  }
</div>
